// src/pages/admin/AdminLayout.tsx
// ============================================================
// Summit League v2 — Admin Layout
//
// Shell component for the admin panel. Renders the sidebar
// navigation and an Outlet for child routes.
//
// Uses useNotifications to pass notification data to the sidebar
// for the dispute badge count.
// ============================================================

import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuthContext } from '../../context/AuthContext';
import { useNotifications } from '../../hooks/useNotifications';
import AdminSidebar from '../../components/admin/AdminSidebar';

import '../../styles/admin-layout.css';

export default function AdminLayout() {
  const { user, isAuthenticated } = useAuthContext();

  const {
    notifications,
    fetchNotifications,
    markAsRead,
    markAllAsRead,
  } = useNotifications({ enabled: isAuthenticated });

  const userRole = (user?.role === 'admin' || user?.role === 'moderator')
    ? user.role
    : 'moderator';

  return (
    <div className="sl-admin">
      <AdminSidebar
        userRole={userRole as 'admin' | 'moderator'}
        notifications={notifications}
      />
      <div className="sl-admin-content">
        <Outlet context={{ notifications, fetchNotifications, markAsRead, markAllAsRead }} />
      </div>
    </div>
  );
}
